import React, { useState, useEffect } from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { FiPhone } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa6";
import { NavLink } from "react-router-dom";
import Plan from "../../components/Modals/Plan";
import TableShimmer from "../../components/Preloader/TableShimmer";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomers } from "../../redux/thunks/addCustomerThunk";
import { Users } from "lucide-react";
import Subscrition from "../../assets/images/svgs/other/subsctibedusers.svg";
import orderImg from "../../assets/images/svgs/other/order.svg";
import Pagination from "../../components/Pagination";
import Collectpay from "../../components/Modals/Collectpay";
import { encryptId } from "../../utils/urlCrypto";

const AllCustomers = ({ filter, search, pageType }) => {
  const dispatch = useDispatch();
  const [isPayOpen, setIsPayOpen] = useState(false);
  const [selectPlan, setSelectPlan] = useState(false);
  const [page, setPage] = useState(1);
  const [payCustomerData, setPayCustomerData] = useState(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const { customers, isCustomerLoading, pagination } = useSelector(
    (state) => state.addCustomers,
  );
  const [curr, setCurr] = useState("");
  const { current_page, total_pages, total_records } = pagination;

  useEffect(() => {
    dispatch(
      getAllCustomers({
        page,
        search,
        page_type: pageType,
        filter,
      }),
    )
      .unwrap()
      .then((res) => {
        // console.log("The res is :", res.data);
        const getCurr = res.data?.currency_symbol;
        setCurr(getCurr);

        
      });
  }, [page, search, pageType, filter, dispatch]);

  useEffect(() => {
    setPage(1);
  }, [search, filter, pageType]);

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const handleShare = (customer) => {
    const message = `Hi ${customer.customer_name}, 
    Your current balance is ${curr} ${Math.abs(customer.current_balance).toFixed(2)}. 
    Regards`;

    const encodedMessage = encodeURIComponent(message);

    const phone = `${customer.country_code}${customer.contact_no}`;

    const url = `https://wa.me/${phone}?text=${encodedMessage}`;

    window.open(url, "_blank");
  };
  return (
    <section className="relative pb-8">
      <DecorativeSquares />

      {/* CUSTOMER LIST */}
      <div className="space-y-4 max-w-7xl mx-auto relative min-h-[400px]">
        {/* ACTUAL CONTENT (always mounted) */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* 1️⃣ LOADING */}
          {isCustomerLoading ? (
            Array(6)
              .fill(0)
              .map((_, i) => <TableShimmer key={i} />)
          ) : customers.length === 0 ? (
            /* 2️⃣ EMPTY */
            <div className="col-span-full flex justify-center items-center py-10 text-gray-400">
              <div className="text-center flex flex-col items-center space-y-3">
                <Users size={65} className="text-gray-300" />
                <h1 className="text-lg font-semibold text-gray-700">
                  No Customers Found
                </h1>
                <p className="text-sm text-gray-500">
                  No Customer for the selected filter
                </p>
              </div>
            </div>
          ) : (
            customers.map((customer) => (
              <div
                key={customer.service_provider_customer_id}
                className="flex items-center justify-between gap-2 bg-white rounded-xl border border-gray-100 p-0 md:p-4 shadow-none md:shadow-sm md:hover:shadow-lg transition duration-300"
              >
                {/* LEFT */}
                <div className="w-full flex items-center justify-between p-3 rounded-xl hover:bg-gray-50 transition">
                  {/* LEFT SIDE */}
                  <div className="flex items-center gap-4 min-w-0">
                    {/* Avatar */}
                    <NavLink
                      to={`/customers-detail/${encryptId(customer.customer_id)}`}
                      className="h-10 w-10 md:h-12 md:w-12 flex-shrink-0 text-xs flex items-center justify-center rounded-xl bg-[#FFEFEB] border border-[#FFCCBF] text-[#FF6943] font-semibold"
                    >
                      {getInitials(customer.customer_name)}
                    </NavLink>

                    {/* Name + Balance */}
                    <div className="flex flex-col min-w-0">
                      <NavLink
                        to={`/customers-detail/${encryptId(customer.customer_id)}`}
                        className="font-semibold text-[#191919] hover:text-[#FB6742] transition text-sm md:text-base truncate"
                      >
                        {customer.customer_name}
                      </NavLink>

                      <div className="flex items-center gap-2">
                        {(() => {
                          const balance = Number(
                            customer?.current_balance || 0,
                          );
                          const isNegative = balance < 0;

                          return (
                            <p
                              className={`text-sm font-semibold whitespace-nowrap ${
                                isNegative
                                  ? "text-red-500 cursor-pointer"
                                  : "text-green-600"
                              }`}
                              onClick={
                                isNegative
                                  ? () => {
                                      setPayCustomerData(customer);
                                      setIsPayOpen(true);
                                    }
                                  : undefined
                              }
                            >
                              {curr} {Math.abs(balance).toFixed(2)}
                            </p>
                          );
                        })()}

                        {customer.is_subscribed && (
                          <img src={Subscrition} className="h-4 w-4" />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* RIGHT SIDE */}
                  <div className="flex items-center gap-2 ml-auto">
                    <button
                      onClick={() => {
                        setSelectPlan(true);
                        setSelectedCustomerId(customer.customer_id);
                      }}
                      className="h-9 w-9 flex items-center justify-center rounded-full border border-[#FB6742] text-[#FB6742]"
                    >
                      <img src={orderImg} alt="order_img" className="h-5 w-5" />
                    </button> 
                    <a
                      className="h-9 w-9 flex items-center justify-center rounded-full border border-[#FB6742] text-[#FB6742]"
                      href={`tel:+${customer.country_code}${customer.contact_no}`}
                    >
                      <FiPhone size={16} />
                    </a> 
                    <a
                      className="h-9 w-9 flex items-center cursor-pointer justify-center rounded-full border border-[#FB6742] text-[#FB6742]"
                      onClick={() => handleShare(customer)}
                      rel="noopener noreferrer"
                    >
                      <FaWhatsapp size={16} />
                    </a>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* PAGINATION */}
      {customers.length > 0 && total_pages > 1 && (
        <>
          <p className="text-sm text-gray-500 text-right mt-4">
            Showing page {current_page} of {total_pages} — {total_records}{" "}
            customers
          </p>
          <Pagination
            current={current_page}
            total={total_pages}
            onPageChange={setPage}
          />
        </>
      )}

      {/* MODAL */}
      <Plan
        open={selectPlan}
        state={{ customerId: selectedCustomerId }}
        onClose={() => setSelectPlan(false)}
        from={"customer"}
      />

      {isPayOpen && payCustomerData && (
        <Collectpay
          open={isPayOpen}
          onClose={() => setIsPayOpen(false)}
          customerRawData={{
            customer_id: payCustomerData.customer_id,
            customer_name: payCustomerData.customer_name,
            contact_no: payCustomerData.contact_no,
            country_code: payCustomerData.country_code,
            amount_due: payCustomerData.current_balance,
            currency_symbol: curr,
          }}
        />
      )}
    </section>
  );
};

export default AllCustomers;
